import type {QueryFunctionContext, UseQueryOptions} from '@tanstack/react-query'
import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'

import type {SupportedLocales} from '@/lib/locale/locale'
import {getNavBanner} from '@/services/commonService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getSiteHeaderQueryKey(params: {locale: SupportedLocales}) {
  return ['siteHeader', params.locale] as const
}

export function getSiteHeaderQueryOptions<TData = string, TError = Error>(
  params: {
    locale: SupportedLocales
  },
  options?: Omit<UseQueryOptions<string, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getSiteHeaderQueryKey(params),
    queryFn: async ({signal}: QueryFunctionContext) => {
      const result = await getNavBanner({locale: params.locale, signal})
      if (!result) throw new Error('Failed to get nav banner')
      return result
    },
    placeholderData: keepPreviousData,
    ...NO_REFETCH_OPTIONS,
    ...options,
  })
}

export default function useSiteHeader(locale: SupportedLocales) {
  return useQuery(
    getSiteHeaderQueryOptions({
      locale,
    }),
  )
}
